import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
    state: {
        showBingPhoneDialog: false,
        shareId: NaN,
        fromBtn: "shareBtn",
        // 临时用户信息
        userInfoTemp: {
            mobile: null,
            auth_code: null,
        },
    },
    mutations: {
        toShowPhoneDialog(state, { fromBtn }) {
            state.showBingPhoneDialog = true;
            if (fromBtn) state.fromBtn = fromBtn;
        },
        setUserInfoTemp(state, userInfoTemp) {
            state.userInfoTemp = userInfoTemp;
        },
        toHidePhoneDialog(state) {
            state.showBingPhoneDialog = false;
        },
        setShareId(state, data) {
            state.shareId = data;
        },
    },
    actions: {},
};
